import { useState, useEffect, useContext } from 'react'
import ContextStates from '../../context/ContextStates'
import { FaPen, FaTrash } from "react-icons/fa";
import axios from 'axios'
import { Url } from '../Url'


const ListadoModelos = () => {

    const { setFormView, setViewOpen, modelos, setModelos, modeloSearch, setModeloSelected, modify } = useContext(ContextStates)

    useEffect(() => {
        const consultaModelos = async () => {
            const formData = new FormData()
            formData.append("modelo", modeloSearch)
            formData.append("marca", 0)
            formData.append("rubro", 0)
            try {
                const response = await axios({
                    url: Url + 'api/listModelos.php',
                    method: 'POST',
                    data: formData,
                })
                setModelos(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaModelos()
    }, [modeloSearch, modify])

    const handleView = (item, action) => {
        setModeloSelected(item)
        setFormView(action)
        setViewOpen(true)
    }


    return (
        <div className="w-full py-5 rounded-2xl">
            <div className="sm:items-start">
                <table className='w-full'>
                    <thead>
                        <tr className='p-1 bg-blue-400 text-white'>
                            <th>Modelo</th>
                            <th>Marca</th>
                            <th>Rubro</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {modelos && (
                            modelos.map((item, index) => (
                                <tr key={index} className={`border border-gray-300 p-2`}>
                                    <td className='text-center'>{item.modelo}</td>
                                    <td className='text-center'>{item.marca}</td>
                                    <td className='text-center'>{item.rubro}</td>
                                    <td className='text-center'>
                                        <button className='bg-gray-400 ml-2 hover:bg-gray-300 rounded p-2 text-white' onClick={() => handleView(item, 10)}><FaPen /></button>
                                        <button className='bg-red-500 ml-2 hover:bg-red-400 rounded p-2 text-white' onClick={() => handleView(item, 11)}><FaTrash /></button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default ListadoModelos